/* Balkan — comportamentele din analiza UX (14 oct. 2026). Vezi balkan-ux.css.
   Trei lucruri, toate fără să schimbe conținutul paginii:
   1. bara de cumpărare pe telefon apare de la încărcare, nu după butonul principal;
   2. rândurile care se derulează lateral arată că mai continuă;
   3. tabelele lungi de pe pagina de produs se pliază pe telefon, cu „Vezi tot".
   Butoanele de pauză ale clipurilor stau în secțiunile lor (promo + comunitate). */
(() => {
  const telefon = matchMedia('(max-width: 749px)');

  /* 1. Bara de cumpărare. Tema (sticky-add-to-cart.js) o arată doar după ce
     butonul principal a ieșit DEASUPRA ecranului. Nu-i atingem logica: punem un
     atribut separat cât butonul principal e încă SUB ecran, iar CSS-ul arată
     bara și în starea asta. Când butonul principal intră în ecran, bara pleacă. */
  const bara = () => {
    const st = document.querySelector('sticky-add-to-cart');
    const bloc = document.querySelector('.buy-buttons-block');
    if (!st || !bloc || !('IntersectionObserver' in window)) return;
    let dedesubt = false;
    const pune = () => st.toggleAttribute('data-bk-early', telefon.matches && dedesubt);
    new IntersectionObserver(([e]) => {
      dedesubt = !e.isIntersecting && e.boundingClientRect.top > 0;
      pune();
    }).observe(bloc);
    telefon.addEventListener('change', pune);
  };

  /* 2. Rândurile derulante. */
  /* Rafturile cu săgeți (`.bk-rail`, `.bk-com2__rail`) NU intră: săgețile spun deja
     că rândul continuă, iar estomparea spăla butonul cardului din dreapta. */
  const RANDURI = '.bk-usp__grid, .bk-col__chips, .bk-pnav__row, .bk-scroll, .bk-reels, .bk-tiles__row';
  const randuri = () => {
    document.querySelectorAll(RANDURI).forEach((r) => {
      const stare = () => {
        const are = r.scrollWidth > r.clientWidth + 4;
        r.classList.toggle('bk-ux-sc', are);
        if (!are) { r.removeAttribute('data-bk-ux-end'); return; }
        r.toggleAttribute('data-bk-ux-end', Math.abs(r.scrollLeft) + r.clientWidth >= r.scrollWidth - 4);
      };
      r.addEventListener('scroll', stare, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(stare).observe(r);
      stare();
    });
  };

  /* 3. Tabelele lungi. Se pliază doar pe telefon și doar dacă chiar sunt lungi. */
  const PLIERI = [
    { sel: '.bk-g2--comp .bk-compv2', max: 520, text: 'Vezi componența completă' },
    { sel: '.bk-g2--vs .bk-vs2b', max: 900, text: 'Vezi toată comparația' },
  ];
  const sageata = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  let nr = 0;
  const plieri = () => {
    if (!telefon.matches) return;
    PLIERI.forEach(({ sel, max, text }) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (el.dataset.bkUxFold || el.scrollHeight < max * 1.35) return;
        el.dataset.bkUxFold = '1';
        if (!el.id) el.id = 'bk-ux-fold-' + (++nr);
        const sec = el.closest('section');
        const fond = sec ? getComputedStyle(sec).backgroundColor : '';
        if (fond && fond !== 'rgba(0, 0, 0, 0)') el.style.setProperty('--bk-ux-bg', fond);
        el.style.setProperty('--bk-ux-max', max + 'px');
        el.classList.add('bk-ux-fold');
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'bk-ux-more';
        b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', el.id);
        b.innerHTML = '<span>' + text + '</span>' + sageata;
        b.addEventListener('click', () => {
          const des = el.classList.toggle('is-open');
          b.setAttribute('aria-expanded', des ? 'true' : 'false');
          b.querySelector('span').textContent = des ? 'Arată mai puțin' : text;
          if (!des) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
        el.after(b);
      });
    });
  };

  const porneste = () => { bara(); randuri(); plieri(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
})();
